import React from 'react';
import { styled } from 'styled-components';
import { ClusteringLabPhoto } from '../types';

interface DragOverlayContentProps {
  photoIds: string[];
  photoMap: Map<string, ClusteringLabPhoto>;
}

const Card = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: visible;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  pointer-events: none;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

const Badge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  background: #3182ce;
  color: white;
  border-radius: 50%;
  min-width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  border: 2px solid white;
`;

const DragOverlayContent: React.FC<DragOverlayContentProps> = ({ photoIds, photoMap }) => {
  const firstPhoto = photoMap.get(photoIds[0]);
  return (
    <Card>
      <Img src={firstPhoto?.photo_url ?? ''} alt="Dragging" />
      {photoIds.length > 1 && <Badge>{photoIds.length}</Badge>}
    </Card>
  );
};

export default DragOverlayContent;
